import { render, staticRenderFns } from "./taikuang.vue?vue&type=template&id=028a3584&scoped=true"
import script from "./taikuang.vue?vue&type=script&lang=js"
export * from "./taikuang.vue?vue&type=script&lang=js"
import style0 from "./taikuang.vue?vue&type=style&index=0&id=028a3584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a3584",
  null
  
)

export default component.exports